import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import TimerIcon from '../../assets/icons/timer.svg';
import HandShakeIcon from '../../assets/icons/handshake.svg';
import WalletIcon from '../../assets/icons/wallet.svg';
import { useCoBrandingParams } from '../../hooks/useCobrandingParams';
import acmMessages from './messages';

const Acm = props => {
  const {
    variantType,
    isMobile = false,
    hideBorder = false,
    inRow = false,
    hideTitle = false,
  } = props;
  const { formatMessage } = useIntl();
  const { isCobranding, dynamicConfig } = useCoBrandingParams();
  const showBorder = !isMobile && !hideBorder && !isCobranding;

  return (
    <div className="flex flex-col justify-center" style={{ gap: '15px' }}>
      {showBorder && <div className="border-2 w-full border-gray-150" />}
      {!hideTitle && (
        <h2 className="title-acm">
          {variantType && formatMessage(acmMessages['acmTitle' + variantType])}
        </h2>
      )}
      <div
        className={`flex ${inRow ? 'flex-col sm:flex-row' : 'flex-col'}`}
        style={{ gap: '10px' }}
      >
        <div
          className={`flex flex-col ${inRow ? 'flex-1' : ''}`}
          style={{ gap: '6px' }}
        >
          <div className="flex items-center">
            <img src={TimerIcon} width={24} height={24} />
            <span className="box-header-acm">
              {variantType &&
                formatMessage(acmMessages['acmTitleOne' + variantType])}
            </span>
          </div>
          <div>
            <span>
              {variantType &&
                formatMessage(acmMessages['acmSubTitleOne' + variantType])}
            </span>
          </div>
        </div>
        <div
          className={`flex flex-col ${inRow ? 'flex-1' : ''}`}
          style={{ gap: '6px' }}
        >
          <div className="flex items-center">
            <img src={HandShakeIcon} width={24} height={24} />
            <span className="box-header-acm">
              {variantType &&
                formatMessage(acmMessages['acmTitleTwo' + variantType])}
            </span>
          </div>
          <div>
            <span>
              {variantType &&
                formatMessage(acmMessages['acmSubTitleTwo' + variantType])}
            </span>
          </div>
        </div>
        <div
          className={`flex flex-col ${inRow ? 'flex-1' : ''}`}
          style={{ gap: '6px' }}
        >
          <div className="flex items-center">
            <img src={WalletIcon} width={24} height={24} />
            <span className="box-header-acm">
              {variantType &&
                formatMessage(acmMessages['acmTitleThree' + variantType])}
            </span>
          </div>
          <div>
            <span>
              {variantType &&
                formatMessage(acmMessages['acmSubTitleThree' + variantType], {
                  // eslint-disable-next-line react/no-multi-comp
                  tac: (...chunks) => (
                    <a
                      className="link"
                      target="_blank"
                      rel="noreferrer"
                      href={dynamicConfig?.termsOfServiceUrl}
                    >
                      {chunks}
                    </a>
                  ),
                })}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

Acm.propTypes = {
  hideBorder: PropTypes.bool,
  hideTitle: PropTypes.bool,
  inRow: PropTypes.bool,
  isMobile: PropTypes.bool,
  variantType: PropTypes.string,
};

export default Acm;
